class GraphQlLiteral {
  constructor(value) {
    this.value = value;
  }
  toString() {
    return `Literal(${this.value})`;
  }
}
export {
  GraphQlLiteral
};
//# sourceMappingURL=GraphQlLiteral.js.map
